import React from 'react';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Heading from '../../../common/Heading';
import formStyles from '../../../styles/forms.module.scss';
import s from './StepGreenPowerData.module.scss';
import {
  TextInput,
  RadioGroupInput,
  AccessibleDatepickerInput,
} from '../../../common/FormFields';
import InfoBox from '../../../common/InfoBox/InfoBox';

function StepGreyPowerData(props) {
  const { values, isGreyPowerConsumptionTooSmall } = props;
  const namePrefix = 'greyPowerData.';
  const intl = useIntl();

  const isControlAreaCustom =
    values &&
    values.greyPowerData &&
    values.greyPowerData.controlArea === 'custom';

  const linkToVerbundProductPortfolio =
    intl.locale === 'en'
      ? 'https://www.verbund.com/en-at'
      : 'https://www.verbund.com/de-at';

  return (
    <>
      <Heading level={2} className={s.heading}>
        <FormattedMessage id="offerWizard.stepGreyPowerData.title" />
      </Heading>
      <div className={formStyles.inputPair}>
        <Field
          name="information.start"
          labelMsg="offerWizard.StepSomeInformation.start.label"
          component={AccessibleDatepickerInput}
          minDate={new Date()}
        />
        <Field
          name="information.end"
          labelMsg="offerWizard.StepSomeInformation.end.label"
          component={AccessibleDatepickerInput}
          minDate={() => {
            if (values.information && values.information.start) {
              return new Date(values.information.start);
            }
            return new Date();
          }}
        />
      </div>
      <div className={formStyles.inputPair}>
        <Field
          name={`${namePrefix}consumption`}
          component={TextInput}
          labelMsg="offerWizard.stepGreenPowerData.consumption.label"
        />
        <Field
          name={`${namePrefix}numberOfMeterPoints`}
          component={TextInput}
          labelMsg="offerWizard.stepGreenPowerData.numberOfMeterPoints.label"
        />
      </div>
      <div role="alert">
        {isGreyPowerConsumptionTooSmall && (
          <InfoBox>
            <Heading level={4}>
              <FormattedMessage id="offerWizard.stepGreenPowerData.isConsumptionTooSmall.title" />
            </Heading>
            <p className={s.consumptionTooSmallText}>
              <FormattedMessage id="offerWizard.stepGreenPowerData.isConsumptionTooSmall.text1" />{' '}
              <a
                href={linkToVerbundProductPortfolio}
                target="_blank"
                rel="noreferrer"
              >
                <FormattedMessage id="offerWizard.stepGreenPowerData.isConsumptionTooSmall.link" />
              </a>
            </p>
          </InfoBox>
        )}
      </div>
      <div className={formStyles.inputWithVerticalSpacing}>
        <Field
          captionMsg="offerWizard.stepGreenPowerData.controlArea"
          name={`${namePrefix}controlArea`}
          options={[
            {
              value: 'apg',
              labelText: 'APG',
            },
            {
              value: 'tennet',
              labelText: 'TenneT',
            },
            {
              value: '50hertz',
              labelText: '50 Hertz',
            },
            {
              value: 'amprion',
              labelText: 'Amprion',
            },
            {
              value: 'transnetBW',
              labelText: 'Transnet BW',
            },
            {
              value: 'custom',
              labelText: intl.formatMessage({
                id: 'offerWizard.stepGreenPowerData.controlArea.other',
              }),
            },
          ]}
          component={RadioGroupInput}
          radioButtonsWrapperClass={s.controlAreaRadios}
        />
        {isControlAreaCustom && (
          <div className={formStyles.inputPairSingle}>
            <Field
              name={`${namePrefix}customControlArea`}
              component={TextInput}
              labelMsg="offerWizard.stepGreenPowerData.controlArea.otherTextInput"
              required
            />
          </div>
        )}
      </div>
      <div className={formStyles.inputWithVerticalSpacing}>
        <Field
          captionMsg="offerWizard.stepGreenPowerData.product"
          name={`${namePrefix}product`}
          options={[
            {
              value: 'fahrplan',
              labelText: 'Fahrplan',
            },
            {
              value: 'standardprodukt',
              labelText: 'Standardprodukt',
            },
          ]}
          component={RadioGroupInput}
          radioButtonsWrapperClass={s.productRadios}
        />
      </div>
    </>
  );
}

StepGreyPowerData.propTypes = {
  values: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    information: PropTypes.object,
    greyPowerData: PropTypes.shape({
      controlArea: PropTypes.string,
    }).isRequired,
  }).isRequired,
  isGreyPowerConsumptionTooSmall: PropTypes.bool.isRequired,
};

export default injectIntl(StepGreyPowerData);
